import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainAgitation } from './components/PainAgitation';
import { HowItWorks } from './components/HowItWorks';
import { MechanismReveal } from './components/MechanismReveal';
import { FeaturedTestimonial } from './components/FeaturedTestimonial';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { CreatorSection } from './components/CreatorSection';
import { BonusStack } from './components/BonusStack';
import { OfferStack } from './components/OfferStack';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { FAQBlock } from './components/FAQBlock';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainAgitation data-id="element-2" />
      <HowItWorks data-id="element-3" />
      <MechanismReveal data-id="element-4" />
      <FeaturedTestimonial data-id="element-5" />
      <TestimonialCarousel data-id="element-6" />
      <CreatorSection data-id="element-7" />
      <BonusStack data-id="element-8" />
      <OfferStack data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQBlock data-id="element-11" />
      <FinalCTA data-id="element-12" />
    </div>;
}